export default __webpack_public_path__ + "static/media/Step-7-safari.ff6689b1.mov";